import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import NavBar from "../general/navBar";
import logo from "../../assets/img/logo.svg";
import activite1 from "../../assets/img/ico/activite/activite1.png";
import activite2 from "../../assets/img/ico/activite/activite2.png";
import activite3 from "../../assets/img/ico/activite/activite3.png";
import activite4 from "../../assets/img/ico/activite/activite4.png";

const Activity = () => {
  return (
    <section className="activity-section">
      <article className="left-content">
        <p className="tag green">Votre domaine, notre expertise</p>
        <h2>Une présence dans tous les secteurs</h2>
        <p>
          On vous accompagne dans votre recrutement,
          <br /> quel que soit votre domaine d’activité.
        </p>
        <Link
          className="nav-links btn fill green"
          to="/candidature/#candidature"
        >
          Candidature
        </Link>
      </article>

      {/* CARTES */}

      <article className="right-content">
        <li className="activity-card one">
          <div className="main-content">
            <img src={activite1} alt="" />
            <h3>Hôtellerie & restauration</h3>
            <p className="text-light">
              Réceptionnistes, personnel de chambres, cuisiniers…
            </p>
          </div>
          <i
            class="fa-solid fa-arrow-right fa-xl"
            style={{ color: "#18c3ba" }}
          ></i>
        </li>
        <li className="activity-card two">
          <div className="main-content">
            <img src={activite2} alt="" />
            <h3>Transport & logistique</h3>
            <p className="text-light">
              Caristes, manutentionnaires, chauffeurs VL/PL…
            </p>
          </div>
          <i
            class="fa-solid fa-arrow-right fa-xl"
            style={{ color: "#18c3ba" }}
          ></i>
        </li>
        <li className="activity-card three">
          <div className="main-content">
            <img src={activite3} alt="" />
            <h3>Vente & Retail</h3>
            <p className="text-light">Vendeurs, hôtes de caisse, stockistes…</p>
          </div>
          <i
            class="fa-solid fa-arrow-right fa-xl"
            style={{ color: "#18c3ba" }}
          ></i>
        </li>
        <li className="activity-card four">
          <div className="main-content">
            <img src={activite4} alt="" />
            <h3>Médical</h3>
            <p className="text-light">
              Infirmiers, aides-soignants, médecins, sage-femmes…
            </p>
          </div>
          <i
            class="fa-solid fa-arrow-right fa-xl"
            style={{ color: "#18c3ba" }}
          ></i>
        </li>
      </article>
    </section>
  );
};

export default Activity;
